<template>
  <VaNavbar class="app-layout-navbar py-2 px-0">
    <template #left>
      <div class="left">
        <Transition v-if="isMobile" name="icon-fade" mode="out-in">
          <VaIcon
            color="primary"
            :name="isSidebarMinimized ? 'menu' : 'close'"
            size="24px"
            style="margin-top: 3px"
            @click="isSidebarMinimized = !isSidebarMinimized"
          />
        </Transition>
        <RouterLink to="/" aria-label="Visit home page">
          <svg width="151" height="34">
            <use :href="`/logo-header.svg`"></use>
          </svg>
        </RouterLink>
      </div>
    </template>
    <template #right>
      <VaButton color="info" class="mr-3" @click="signOut">Sign out </VaButton>
    </template>
  </VaNavbar>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useRouter } from 'vue-router'
import { useGlobalStore } from '../../stores/global-store'
import { useAuthStore } from '../../stores/auth'

defineProps({
  isMobile: { type: Boolean, default: false },
})

const { push } = useRouter()
const authStore = useAuthStore()
const GlobalStore = useGlobalStore()

const { isSidebarMinimized } = storeToRefs(GlobalStore)

const signOut = () => {
  authStore.signOut()
  push({ name: 'login' })
}
</script>

<style lang="scss" scoped>
.app-layout-navbar {
  min-height: 70px;
}
.va-navbar {
  z-index: 2;

  @media screen and (max-width: 950px) {
    .left {
      width: 100%;
    }

    .app-navbar__actions {
      display: flex;
      justify-content: space-between;
    }
  }
}

.left {
  display: flex;
  align-items: center;
  margin-left: 1rem;

  & > * {
    margin-right: 1rem;
  }

  & > *:last-child {
    margin-right: 0;
  }
}

.icon-fade-enter-active,
.icon-fade-leave-active {
  transition: transform 0.5s ease;
}

.icon-fade-enter,
.icon-fade-leave-to {
  transform: scale(0.5);
}
</style>
